export const DIGITAL_KEY_ERRORS = {
  NOT_SET: -1,
  NOT_NATIVE: -2,
  MISSING_DATA: -3,
  CAN_START_DOOR_OPENING_EXCEPTION: -4
}

export const MESSAGES_ALLOWED_TO_REPEAT = ['openDoor', 'canStartDoorOpening', 'addToCalendar']
